import { DocumentData } from "@1games-ru/region-shared/dist/types/documents/documentData";
import clsx from "clsx";

function Field({ label, value, className }: { label?: string; value: string; className?: string }) {
  return (
    <div className={className}>
      <div className="text-dark-800/80 text-15">{label}</div>
      <div
        className={clsx(
          "text-left text-dark-800 text-14 uppercase",
          "py-2.5 border-b border-[#175D83]",
        )}
      >
        {value}
      </div>
    </div>
  );
}

export default function PsychiatricCertificate({
  docNumber,
  issuedAt,
  issuer,
  owner,
  expiresAt,
}: DocumentData) {
  return (
    <div
      className={clsx(
        "flex flex-col w-[26.5rem] h-[34.125rem] rounded-[0.5rem] overflow-clip ",
        "text-dark-800 p-[1.875rem] bg-[#DDEFF9]",
      )}
      style={{
        backgroundImage: "url(./svg/documents/psy-certificate.webp)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div className="text-[#175D83] text-16 font-medium">СПРАВКА</div>
      <div className="text-[#175D83] text-15 mt-0.5">Психоневрологический диспансер</div>
      <div className="text-15 font-medium mt-2.5">№ 16430100010</div>
      <div className="flex flex-col gap-5 mt-5">
        <Field label="Имя Фамилия пациента" value={[owner.lastName, owner.firstName].join(" ")} />
        <Field label="Номер медицинской карты" value={String(docNumber)} />
        <Field
          label="Сведений о лечении и наблюдении в наркотических учреждений по месту регистрации"
          value="-"
        />
        <div className="grid grid-cols-2 gap-5">
          <Field label="Дата выдачи" value={issuedAt} />
          <Field label="Срок действия" value={expiresAt || "-"} />
        </div>
        <div className="relative">
          <Field label="Выдано врачом" value={issuer.name} />
          <img
            src="./svg/documents/seal-healthcare-service.webp"
            alt=""
            className="z-1 w-[6.25rem] aspect-square absolute -bottom-[2rem] left-[9.5rem] pointer-events-none rotate-12"
          />
          <img
            src="./svg/dark-signature.svg" // TODO: {issuer.signature}
            alt=""
            className="z-1 absolute h-[4rem] w-fit -bottom-[1rem] right-0 pointer-events-none"
          />
        </div>
      </div>
    </div>
  );
}
